import React from 'react';
import Header from '../common/Header';
import PageTitle from '../common/PageTitle';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import './SideMenuLayout.css';

interface Props {
  title: string;
  nav: React.ReactNode;
  actions?: React.ReactNode;
  /** Browser tab title when it should differ from the page heading (e.g. "Admin: Users"). */
  documentTitle?: string;
  children: React.ReactNode;
}

/** Shared shell for areas with a side menu (account, admin). Phones get the menu as a tab row. */
const SideMenuLayout: React.FC<Props> = ({ title, nav, actions, documentTitle, children }) => {
  useDocumentTitle(documentTitle || title);
  return (
    <div className="side-layout-page">
      <Header />
      <div className="container side-layout">
        {nav}
        <main className="side-layout__main">
          <PageTitle title={title} actions={actions} />
          {children}
        </main>
      </div>
    </div>
  );
};

export default SideMenuLayout;
